<template>
  <ViewCustomData entityName="property" entitySpec="facility" serviceName="BaseService"
    :columns="FACILITY_PROPERTY_DLG_COLUMNS" :dictionary="dictionary" @selectedRow="onSelectedRow" @delete="onDeleteRow"
    :masterDetail="{ facility_id: facilityId }" scrollHeight="400px" ref="viewFacilityPropertyWithDlg"
    :paginator="false" :requiredFieldsTable="FACILITY_PROPERTY_REQUIRED_FILEDS" :dialogOptions="dialogOptions"
    :dialog="FacilityPropertyDialog" @dictIsReady="dictIsReady" :prepareData="prepareData">
    <template #toolbar>
      <div class="component-filter gap-1">
        <Button label="Заменить путь" severity="success" icon="pi pi-folder"
          style="white-space: nowrap; min-width: 140px;" :disabled="!store.getters.info.isAdmin"
          @click="emit('changePath')" />
        <Button label="Устройства" severity="success" icon="pi pi-cog" :disabled="!store.getters.info.isAdmin"
          @click="emit('changeDevice')" />
      </div>
    </template>
  </ViewCustomData>
</template>

<script setup>
import axios from 'axios';
import { shallowRef, ref, computed, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import FacilityPropertyDialog from './FacilityPropertyDialog.vue';
import { FACILITY_PROPERTY_DLG_COLUMNS, FACILITY_PROPERTY_DICTIONARY, FACILITY_PROPERTY_REQUIRED_FILEDS } from './facilityConstants';

const store = useStore();

const props = defineProps({
  facilityId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['selected', 'loadData', 'changePath', 'changeDevice', 'dictIsReady']);

const FacilityPropertyDialogRef = shallowRef(FacilityPropertyDialog);
const selected = ref(null);
const sourceIsEmpty = ref(false);
const dialogOptions = ref({});
const viewFacilityPropertyWithDlg = ref(null);

const addSourceFromData = (row) => ({
  source: row.property_path,
  property_path: row.property_path,
});

const loadSourceFromData = (data) => {
  const result = [];
  data.forEach((item) => {
    result.push(addSourceFromData(item));
  });
  return result;
};

const loadSource = async () => {
  const login = store.getters.info.login;
  const password = store.getters.password;
  const api = `${store.getters.server('TM_MIDDLE')}kron.tm3.service-web-1.0/webresources/restservice/opcsourcesitems/${props.facilityId}`;
  const headers = {
    Authorization: 'Basic ' + btoa(login + ':' + password),
  };
  try {
    const { data } = await axios.get(api, { headers });
    const result = [];
    if (data?.length) {
      data.forEach((element) => {
        result.push({ source: element, property_path: element });
      });
    }
    return result;
  } catch (er) {
    store.commit('SET_ERROR', {
      er: er.response || er,
      source: ['FacilityPropertyWithDlg', 'loadSource'],
    });
    return [];
  }
};

const dictionary = computed(() => {
  const base = [...FACILITY_PROPERTY_DICTIONARY];
  const extras = [
    {
      options: 'device',
      save: { store: false, self: true },
      load: 'db',
      params: {
        facility_id: props.facilityId,
      },
      serviceName: 'BaseService',
      entityName: 'device',
      entitySpec: 'data',
    },
    {
      options: 'source',
      save: { store: false, self: true },
      load: 'parent',
      data: loadSource,
      entityName: 'source',
    },
  ];
  return [...base, ...extras];
});

const dictIsReady = (options, data) => {
  dialogOptions.value[options] = data;
  if (options === 'device') {
    emit('dictIsReady', options, data);
  }
  if (options === 'source') {
    sourceIsEmpty.value = !data.length;
  }
};

const onSelectedRow = (value) => {
  selected.value = value;
  if (value?.property_type_id || value?.property_id) {
    emit('selected', {
      property_id: value.property_id,
      property_type_id: value.property_type_id,
      property_type_desc: value.property_type_desc,
    });
  }
};

const onDeleteRow = () => {
  emit('selected', {
    property_id: null,
    property_type_id: null,
    property_type_desc: null,
  });
}

const prepareData = (data) => {
  if (data.length) {
    if (viewFacilityPropertyWithDlg.value) {
      viewFacilityPropertyWithDlg.value.selected = data[0];
    }
    if (sourceIsEmpty.value) {
      dialogOptions.value.allSource = loadSourceFromData(data);
      sourceIsEmpty.value = false;
    }
  }
  emit('loadData', data, 'FacilityProperty');
  return data;
};

</script>